/**
 * * @param {string} desktopSrc - Ruta de la imagen para escritorio.
 * @param {string} [mobileSrc] - Ruta opcional de la imagen para móvil.
 * @param {string} alt - Texto alternativo para la imagen.
 * @param {string} [className] - Clases CSS opcionales.
 */
function ResponsiveImage({ desktopSrc, mobileSrc, alt, className, ...props }) {
  if (!mobileSrc) {
    return <img src={desktopSrc} alt={alt} className={className} {...props} />;
  }

  // Si hay versión móvil, renderiza el elemento <picture> completo.
  return (
    <picture>
      {/* Para pantallas de 600px o menos, usa la imagen móvil */}
      <source media="(max-width: 600px)" srcSet={mobileSrc} />
      
      {/* Para pantallas más grandes, usa la imagen de escritorio */}
      <source media="(min-width: 601px)" srcSet={desktopSrc} />
      
      {/* Respaldo obligatorio y para definir el 'alt' text y estilos */}
      <img src={desktopSrc} alt={alt} className={className} {...props} />
    </picture>
  );
}

export default ResponsiveImage;